const useGetCXAppLink = () => {
  return "";
};

export default useGetCXAppLink;
